<template>
  <div class="data-performance-score-card">
    <header class="header">
      <p class="header-title-performance">
        <span>Data Performance Score</span>
        <i
          class="fa fa-info-circle help-icon ml-5"
          v-b-tooltip.hover="{
            placement: 'rightbottom',
            title:
              'This score represents a compilation of metrics related to the clinical and operational data collected within the THREAD Platform for this study. A low score can represent problems with one or more of the following: outstanding queries, missing data, multiple data changes, or a high number of overall queries. A high score represents little to no issues with the aforementioned categories. The score shown here is based on a scale from 1 to 10 with the higher number being more desirable. The number associated with the up or down arrow represents the change in this score over the past week.'
          }"
        />
      </p>
    </header>

    <div class="wrapper-content">
      <div :class="score == 0 ? 'body emptyData' : 'body'">
        <p class="body-val" v-if="score >= 0 && dataLoaded">{{ score }}</p>
        <p class="body-val emptyData align-content-textarea" v-else>
          <span class="card-text-title no-data" v-if="dataLoaded">No Data In</span>
        </p>
        <div class="trend-score" v-if="score >= 0 && dataLoaded">
          <div v-if="isHigher === 'yes'" class="arrow-up"></div>
          <div :class="isHigher === 'yes' ? 'text-up' : isHigher === 'no' ? 'text-down' : 'text-equal'">{{ isHigher === "yes" ? "+" : "" }}{{ parseFloat(upScore).toFixed(1) }}</div>
          <div v-if="isHigher === 'no'" class="arrow-down"></div>
          <div v-if="isHigher === ''" class="arrow-equal"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    score: [Number, String],
    upScore: [Number, String],
    isHigher: [String, Number],
    dataLoaded: { type: Boolean, default: false }
  }
};
</script>
<style lang="scss" scoped>
.data-performance-score-card {
  flex: auto;
  flex-flow: column nowrap;
  padding: 10px;
  border-radius: 4px;
  background-color: #35537e;
  min-width: 249px;
  min-height: 130px;
  margin-left: 22px;

  .header {
    margin: 0 0 8px;

    .header-title-performance {
      position: relative;
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      margin: 0;
      font-family: "Roboto-Medium";
      font-size: 14px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;

      .flex-in-icon {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-left: 4px;
      }
    }
  }

  .wrapper-content {
    display: flex;
    justify-content: space-around;
  }

  .body {
    width: 50%;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-evenly;
    align-items: center;

    &.emptyData {
      width: 100%;
    }

    .body-val {
      flex-grow: 0;
      font-family: "Roboto-Bold";
      font-size: 58px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      margin: 0 4px 0 0;

      &.emptyData {
        font-size: 14px;
        color: #959fa4;
        font-weight: normal;
      }
    }

    .trend-score {
      display: flex;
      align-items: center;
      flex-flow: column wrap;
    }
  }

  .arrow-up {
    width: 0;
    height: 0;
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;

    border-bottom: 20px solid #48bf7a;
  }

  .arrow-down {
    width: 0;
    height: 0;
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;

    border-top: 20px solid #ff4040;
  }

  .arrow-equal {
    width: 25px;
    height: 4px;
    margin: 1px 0 0;
    background-color: #959fa4;
  }

  .text-up {
    font-family: "Roboto-Regular";
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    margin: 4px 0;

    color: #48bf7a;
  }

  .text-down {
    @extend .text-up;

    color: #ff4040;
  }

  .text-equal {
    @extend .text-up;

    color: #959fa4;
  }
}
</style>
